<template>
  <div class="coinOutHistory">
    <!--头部-->
    <!--<van-nav-bar class="wallet-header" title="转移记录" left-arrow @click-left="onClickLeft" border />-->
    <div class="bg-10px"></div>
    <div class="list-con">
      <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            :error.sync="isError"
            error-text="请求失败，点击重新加载"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <div class="list clickable" v-for="(item, i) in dataList" :key="i">
            <div class="img-con">
              <img class="img" :src="checkQiNiuUrl('FuVnTj-DQeClAwtKrQdW_m-uS-YM')" alt="">
            </div>
            <div class="text-con">
              <p class="text">{{ item.title }}<span v-if="item.remarks">{{ '(' + item.remarks + ')' }}</span></p>
              <p class="order">订单记录：<span>{{ item.recordSn }}</span></p>
              <p class="time">{{ item.createTime | dataFormat('yyyy-MM-dd hh:mm:ss') }}</p>
            </div>
            <div class="right-con">
              <p class="num" :class="{red: (item.amount < 0) }">{{ item.amount | filterCoin }} 枚</p>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>


    </div>
  </div>
</template>

<script>
  import { antCoinRecord } from '@/api/wallet/integral'
  export default {
    components: {
    },
    data () {
      return {
        userOpenId: this.session('userOpenId'),
        dataList: [], // 列表数据
        refreshLoading: false,

        loading: false,
        finished: false,
        isError: false,

        page: 1,
        size: 10,
      }
    },
    methods:{
      onClickLeft() {
        this.$router.go(-1)
      },
      onRefresh(){
        this.page = 1;
        window.setTimeout(()=>{
          this.finished = false;
          this.dataList = [];
          this.refreshLoading = false;
          window.scrollTo(0, 10);
        },100)
      },
      onLoad() {
        antCoinRecord({
          openId: this.userOpenId,
          walletType: 0,
          productCode: 'AntCoin',
          type: 2, //交易类型，0：全部 1：充值 2：转帐 3：奖励 4：红包
          page: this.page,
          size: this.size
        }).then(res => {
          if(res.data.items.length>0){ //是否有数据
            let arr = res.data.items
            // 如果是第一页需手动制空列表
            if (this.page === 1){
              this.dataList = [];
            }
            // 把请求到的数据添加到列表
            this.dataList = this.dataList.concat(arr)
            this.page++
            this.loading = false

          }else {
            this.loading = false;
            this.finished = true;
          }
        }).catch(() => {
          this.error = true;
        })
      },

    }
  }
</script>

<style scoped lang="less">
.coinOutHistory{
  height: 100%;
  .list-con{
    margin-top: 10px;
    .van-list{
      min-height: 300px;
    }
    .list{
      display: flex;
      align-items: center;
      min-height: 80px;
      border-bottom: 1px solid rgb(238,238,238);
      .img-con{
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        .img{
          width: 34px;
          height: 34px;
        }
      }
      .text-con{
        font-size: 12px;
        color: rgb(13,12,12);
        width: 195px;
        height: 100%;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        .text{
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: pre-line;
          line-height: 1;
          padding: 3px 0;
          font-size: 16px;
        }
        .order{

        }
        .time{
          color: rgb(102,102,102);
        }
      }
      .right-con{
        flex: 1;
        display: inline-flex;
        justify-content: center;
        align-items: flex-end;
        flex-direction: column;
        color: rgb(43,43,43);
        padding-right: 10px;
        height: 100%;
        font-size: 14px;
        .num{
          max-width: 102px;
          white-space: pre-wrap;
          word-break:break-all;
          text-align: right;
        }
        .text{
          font-size: 12px;
          padding-top: 9px;
        }
      }
      .red{
        color: rgb(253,92,64);
      }
    }
  }
}
</style>
